module.exports = __webpack_public_path__ + "static/media/bootstrap.70357d73.png";